import { IStaticConfig } from '../typings';

export const siteid70901: IStaticConfig = {
  changeSearch : {
    timeDropdown12Hr : true
  }
};
